import React from 'react';
import FeatureAccessGuard from './FeatureAccessGuard';
import { FEATURE_NAMES } from '../../apis/featureLimits';
import Posttext from '../posttext';

// Wrapper component that adds feature limiting to Create Posts
const PostTextWithLimits = () => {
  return (
    <FeatureAccessGuard 
      featureName={FEATURE_NAMES.MANUAL_POSTS}
      customMessage="Create posts are limited to 1 for free users. Subscribers have unlimited access."
    >
      <Posttext />
    </FeatureAccessGuard>
  );
};

export default PostTextWithLimits;
